import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TableColumn } from "react-data-table-component";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import { PageV2 } from "containers/PageV2";
import { ModalCustom } from "components/ModalCustom";
import { LoadingScreen } from "components/LoadingScreen";
import { toastErro } from "components/Toast";
import { usePagamentoTaxa } from "./hooks/usePagamentoTaxa";
import { IFiltroPagamentoTaxa } from "./interfaces/IFiltroPagamentoTaxa";
import { FiltroPagamentoTaxa } from "./containers/filtro";
import { ListarLotesPagamento } from "./containers/lista";

export function PagamentoTaxa() {
  const navigate = useNavigate();
  const {
    totalRows,
    limit,
    loading,
    setPage,
    setLimit,
    filtro,
    dadosLotes,
    listarLotes,
    relatorioLotes,
    excluirLote,
    validarProcessos,
    validarVeiculos,
  } = usePagamentoTaxa();

  const [loteParaExcluir, setLoteParaExcluir] = useState<number | null>(null);
  const [sucessoRemocao, setSucessoRemocao] = useState(false);
  const [versaoBusca, setVersaoBusca] = useState(0);

  useEffect(() => {
    listarLotes(filtro);
  }, []);

  const submitFiltro = (dados: IFiltroPagamentoTaxa) => {
    setPage(1);
    setVersaoBusca((v) => v + 1);
    listarLotes(dados, 1, limit);
  };

  const handlePageChange = (novaPagina: number) => {
    setPage(novaPagina);
    listarLotes(filtro, novaPagina, limit);
  };

  const handleLimitChange = (novoLimite: number) => {
    setLimit(novoLimite);
    setPage(1);
    listarLotes(filtro, 1, novoLimite);
  };

  const handleOnSort = (coluna: TableColumn<any>, direcao: string) => {
    setPage(1);
    listarLotes(filtro, 1, limit, coluna.sortField, direcao);
  };

  const handleVerDetalhes = (idLote: number) => {
    navigate(`/financeiro/pagamento-taxa-sp/lote/criar/${idLote}`);
  };

  const handleExcluir = (idLote: number) => {
    setLoteParaExcluir(idLote);
  };

  const confirmarExclusao = async () => {
    if (loteParaExcluir == null) return;

    const { hasErro, data } = await excluirLote(loteParaExcluir);
    setLoteParaExcluir(null);

    if (hasErro) {
      toastErro(data?.message ?? "Não foi possível excluir o lote.");
      return;
    }

    setSucessoRemocao(true);
    listarLotes(filtro);
  };

  const fecharModalRemover = () => {
    setLoteParaExcluir(null);
    setSucessoRemocao(false);
  };

  const onClickCriarLote = () => {
    navigate("/financeiro/pagamento-taxa-sp/lote/criar");
  };

  return (
    <PageV2 title="Pagamento de Taxa SP">
      <LoadingScreen mostrar={loading} />
      <FiltroPagamentoTaxa
          submitForm={submitFiltro}
          validarProcessos={validarProcessos}
          validarVeiculos={validarVeiculos}
        />
        <ListarLotesPagamento
          dados={dadosLotes}
          versaoBusca={versaoBusca}
          totalRows={totalRows}
          loading={loading}
          linhasPorPagina={limit}
          handlePageChange={handlePageChange}
          handleLimitChange={handleLimitChange}
          handleVerDetalhes={handleVerDetalhes}
          handleExcluir={handleExcluir}
          onSort={handleOnSort}
          onClickCriarLote={onClickCriarLote}
          relatorioLotes={relatorioLotes}
        />

      <ModalCustom
        show={loteParaExcluir != null || sucessoRemocao}
        handleClose={fecharModalRemover}
        title="Remover lote"
        centered
        footer={!sucessoRemocao}
        footerConfirmButton={!sucessoRemocao}
        cancelButtonText="Cancelar"
        confirmButtonText="Remover"
        onCancel={fecharModalRemover}
        onConfirm={confirmarExclusao}
      >
        <div style={{ textAlign: "center", padding: "8px 0" }}>
          {sucessoRemocao ? (
            <>
              <FaCheckCircle
                size={36}
                color="#10AC85"
                style={{ marginBottom: 16 }}
              />
              <p style={{ margin: 0 }}>Lote removido!</p>
            </>
          ) : (
            <>
              <FaExclamationCircle
                size={36}
                color="#FF9F42"
                style={{ marginBottom: 16 }}
              />
              <p style={{ margin: 0 }}>Deseja remover o lote selecionado?</p>
            </>
          )}
        </div>
      </ModalCustom>
    </PageV2>
  );
}
